import { DownloadIcon } from './Icons';
import LoadingIcon from './LoadingIcon';
import DownloadMenu from './DownloadMenu';

interface DownloadControlProps {
  id: string;
  file: any;
  dimensions: any;
  isImage: boolean;
  showDownloadMenu: boolean;
  downloadingSize: string;
  loadingCropTool: boolean;
  menuClassName: string;
  iconClassName: string;
  iconWrapperClassName: string;
  downloadFile: (id: number, filename: string, size: string) => void;
  openCropTool: (id: number) => void;
  toggleActiveDownloadMenu: (id: string) => void;
}

const DownloadControl = ({
  id,
  file,
  dimensions,
  isImage,
  showDownloadMenu,
  downloadingSize,
  loadingCropTool,
  menuClassName,
  iconClassName,
  iconWrapperClassName,
  downloadFile,
  openCropTool,
  toggleActiveDownloadMenu,
}: DownloadControlProps) => {
  if (isImage) {
    return (
      <>
        <div className="relative ">
          <button
            className={iconWrapperClassName}
            onClick={() => {
              toggleActiveDownloadMenu(id);
            }}
          >
            <DownloadIcon className={iconClassName} />
          </button>
        </div>
        {showDownloadMenu && (
          <DownloadMenu
            file={file}
            dimensions={dimensions}
            downloadingSize={downloadingSize}
            loadingCropTool={loadingCropTool}
            className={menuClassName}
            downloadFile={downloadFile}
            openCropTool={openCropTool}
          />
        )}
      </>
    );
  }

  return downloadingSize === 'file' ? (
    <LoadingIcon className="w-5 h-5 my-0.5 text-accent animate-spin" />
  ) : (
    <button
      onClick={() => downloadFile(file.ID, file.file, 'file')}
      className="inline-block text-xs text-left hover:text-gray-400 "
    >
      <DownloadIcon className={iconClassName} />
    </button>
  );
};

export default DownloadControl;
